<template>
    <div class="content">
        <div class="md-layout">
        <div
            class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
        >
            <stats-card data-background-color="green">
                <template slot="header">
                    <font-awesome-icon class="fs-3" :icon="['fas', 'charging-station']" />
                    <span class="fs-6">Day</span>
                </template>

                <template slot="content">
                    <p class="category">本日發電量</p>
                    <h3 class="title">{{all_plant_stats.today.kwh_str}}
                    <br>
                    <small>kWh</small>
                    </h3>
                </template>

                <template slot="footer">
                    <div class="stats d-flex align-items-center">
                    <md-icon>paid</md-icon>
                    本日收益：
                    <h4>{{all_plant_stats.today.fee_str}}</h4>
                    <small>元</small>
                    </div>
                </template>
            </stats-card>
        </div>
        <div
            class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
        >
            <stats-card data-background-color="orange">
            <template slot="header">
                <font-awesome-icon class="fs-3" :icon="['fas', 'charging-station']" />
                <span class="fs-6">Month</span>
            </template>

            <template slot="content">
                <p class="category">本月發電量</p>
                <h3 class="title">{{all_plant_stats.month.kwh_str}}
                <br>
                <small>kWh</small>
                </h3>
            </template>

            <template slot="footer">
                <div class="stats d-flex align-items-center">
                <md-icon>paid</md-icon>
                本月收益：
                <h4>{{all_plant_stats.month.fee_str}}</h4>
                <small>元</small>
                </div>
            </template>
            </stats-card>
        </div>
        <div
            class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
        >
            <stats-card data-background-color="blue">
            <template slot="header">
                <font-awesome-icon class="fs-3" :icon="['fas', 'charging-station']" />
                <span class="fs-6">Year</span>
            </template>


            <template slot="content">
                <p class="category">本年發電量</p>
                <h3 class="title">{{all_plant_stats.year.kwh_str}}
                <br>
                <small>kWh</small>
                </h3>
            </template>

            <template slot="footer">
                <div class="stats d-flex align-items-center">
                <md-icon>paid</md-icon>
                本年收益：
                <h4>{{all_plant_stats.year.fee_str}}</h4>
                <small>元</small>
                </div>
            </template>
            </stats-card>
        </div>
    </div>
        <div class="home_page">
            <div id="maploader"></div>
            <taiwan3D :get3d-points="cityStations" v-if="cityStations.length != 0" @tw3d-finish="tw3dFinish" />
            <stationChange :city-stations="stationData" v-if="stationData.length != 0 && cityStations.length != 0" />
        </div>
    </div>
</template>

<script>
import taiwan3D from '../components/map/taiwan3D.vue'
import stationChange from '../components/map/stationChange.vue'
import statsCard from '@/components/Cards/StatsCard.vue'

export default {
	name: 'Show',	
	components: { 
		taiwan3D, stationChange, statsCard
	},
	data() {
		return {
			cityStations: [],
            all_plant_stats: {},
            stationData: [],
		}
	},
	mounted() {
		let that = this
        that.create_pvPlantCard()
        this.syncdata = setInterval(function(){
			that.tawian3d_plant_overview()
			that.create_pvPlantCard()
		}, 1000)
	},
	destroyed(){
		clearInterval(this.syncdata)
	},
	methods: {
		tw3dFinish(){
			//等待taiwan3D mount 好
			//因為request要時間，所以taiwan3D不能馬上載入
			//等初次request下來，tawian3D才載入
			//這邊把 播放自選案紐關掉的
			document.querySelector('.tw_switch').style.display = 'none'
		},
		openStation(){
			this.$refs.stationPop.$el.style.display = 'block';			
			document.body.classList.add('lock');
		},
		tawian3d_plant_overview(){
			let that = this
			this.axios.get('/tawian3d_plant_overview').then(function(data){
				//console.log(data.data.data)
				that.cityStations = data.data.data
			})
		},
        create_pvPlantCard(){
            let that = this
            this.axios.get("/pv_plant_information")
            .then(function (data) {
                //console.log(data.data)
                that.all_plant_stats = data.data.all_plant_stats
                that.stationData = []
                data.data.information.forEach(element => {
                    that.stationData.push({
                        name: element.name,
                        show_data: [
                            {"title": "本日發電量", "numb": element.data.kwh_today, "unit": "kWh"},
                            {"title": "本月發電量", "numb": element.data.kwh_month, "unit": "kWh"},
                            {"title": "本年發電量", "numb": element.data.kwh_year, "unit": "kWh"},
                            {"title": "等效發電小時", "numb": element.data.DMY, "unit": "小時"},
                            {"title": "PR", "numb": element.data.PR, "unit": "%"},
                            {"title": "今日收益", "numb": parseInt(element.data.kwh_today*element.fee), "unit": "元"}

                        ]
                    })
                });
            })
            },
	}
}
</script>